import { Link } from "react-router-dom";

export const MenuItem = ({ icon: Icon, to, children, isActive, collapsed, mobileOpen }) => (
  <Link
    to={to}
    className={`group flex items-center h-10 px-3 rounded-lg transition-all duration-200 ${
      isActive
        ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/25"
        : "text-gray-700 hover:bg-blue-50 hover:text-blue-700"
    }`}
  >
    <Icon
      className={`w-4 h-4 transition-transform duration-200 ${
        collapsed && !mobileOpen ? "mx-auto" : ""
      } ${isActive ? "" : "group-hover:scale-110"}`}
      strokeWidth={isActive ? 2 : 1.5}
    />
    {(!collapsed || mobileOpen) && (
      <span className="ml-2 text-sm font-medium tracking-wide">{children}</span>
    )}
  </Link>
);
